import FuseAnimate from '@fuse/core/FuseAnimate';
import { ThemeProvider, Tooltip, Typography } from '@material-ui/core';
import * as PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { Container, ContainerChildren, ContainerDescription, ContainerSearch } from './styles';

const PageHeader = ({ title, icon, info, button, children, placement, description }) => {
  const mainTheme = useSelector(({ fuse }) => fuse.settings.mainTheme);

  return (
    <Container>
      <ContainerDescription className="mt-16 mr-16">
        <FuseAnimate animation="transition.expandIn" delay={300}>
          <div className="text-32 ml-4">{icon}</div>
        </FuseAnimate>
        <FuseAnimate animation="transition.slideLeftIn" delay={300}>
          <Typography className="hidden sm:flex mx-0 sm:mx-12" variant="h6">
            {title}
          </Typography>
        </FuseAnimate>
        <FuseAnimate animation="transition.expandIn" delay={300}>
          <Tooltip title={description || ''} placement={placement}>
            <div className="text-32">{info}</div>
          </Tooltip>
        </FuseAnimate>
      </ContainerDescription>
      <ContainerSearch>
        <ThemeProvider theme={mainTheme}>{children}</ThemeProvider>
      </ContainerSearch>
      {button !== 'false' && (
        <ContainerChildren>
          <FuseAnimate animation="transition.slideDownIn" delay={300}>
            <div>{button}</div>
          </FuseAnimate>
        </ContainerChildren>
      )}
    </Container>
  );
};

PageHeader.propTypes = {
  title: PropTypes.node,
  description: PropTypes.node,
  placement: PropTypes.string,
  icon: PropTypes.node,
  info: PropTypes.node,
  children: PropTypes.node,
  button: PropTypes.node,
};

PageHeader.defaultProps = {};

export default PageHeader;
